import "./App.css";
import { useState, useEffect } from "react";
import Header from "./component/Header";
import Mapca from "./component/Mapca";
import Infoip from "./component/Infoip";

function App() {
  const [ErorMsg, setMsg] = useState(false);
  const [ipinfo, setIpinfo] = useState();
  const [ip, setIp] = useState('');
  

  useEffect(() => {
    const getIpDa = async(ip)=>{
    const res = await fetch(
      `https://geo.ipify.org/api/v1?apiKey=at_v95pwGe8qaQ0OLg7sXV1YjbAHRT7X&ipAddress=${ip}`
    );
    const data = await res.json();
    console.log(data);
    setIpinfo(data);
    setMsg(false);
    }
    getIpDa(ip);
  }, [ip]);

  const ipData = (IP) => {
    
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(IP)) {  
      setIp(IP); 
    }
    else{
      setMsg(true);
    }
  };

  return (
    <div className="App">
      <Header clickEvenet={ipData} Msg={ErorMsg} />
      <Infoip infoIp={ipinfo}/>
      <Mapca infoIp={ipinfo}/>
    </div>
  );
}

export default App;
